module.exports = __webpack_public_path__ + "static/img/miniProjectImg.5e28dd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/miniProjectImg.jpg
// module id = mBDE
// module chunks = 1